export const createDownloadLockName = (scope) => `download-${scope}`;
